import { Button } from "antd"
import { connect } from 'react-redux'
import moment from 'moment'

function GenerateInvoiceButton ({ selectedQtr, plugins, waitingForJobs, setWaitingForJobs, setJobTimestamp }) {

  const orchestrator = plugins['weaver-orchestrator']

  const getFunctionalityVersion = async () => {
    const functionalities = await orchestrator.getFunctionalities()
    const parsedFunctionalities = JSON.parse(functionalities)
    return parsedFunctionalities.find((f) => f.name === "pmsccy.invoice").version
  }

  const getRelevantTaskUid = async (funcName) => {
    const tasks = JSON.parse(await orchestrator.getSchedules())
    const relevantTasks = tasks.filter((t) => t.functionalityName === funcName)
    const sorted = relevantTasks.sort((a, b) => new Date(b.created) - new Date(a.created))
    return sorted[0] ? sorted[0].uid : undefined
  }

  const updateConfig = async (uid, year, qtr) => {
    await orchestrator.updateConfiguration({
      userId: Weaver.getInstance().currentUser().id(),
      scheduleUid: uid,
      config: {
        year: parseInt(year),
        quarter: parseInt(qtr.substring(1))
      }
    })
  }

  const createNew = async (year, qtr) => {
    const functionalityVersion = await getFunctionalityVersion()
    const taskObj = {
      branch: "main",
      config: {
        year: parseInt(year),
        quarter: parseInt(qtr.substring(1))
      },
      functionalityVersion,
      functionalityName: "pmsccy.invoice",
      userId: Weaver.getInstance().currentUser().id()
    }

    return orchestrator.schedule(taskObj)
  }

  const handleFormSubmission = async () => {
    setWaitingForJobs(true)
    setJobTimestamp(Date.now())
    const [selectedYear, selectedQuarter] = selectedQtr
    let scheduleUid = await getRelevantTaskUid("pmsccy.invoice")

    try {
      if (scheduleUid) {
        await updateConfig(scheduleUid, selectedYear, selectedQuarter)
      } else {
        scheduleUid = await createNew(selectedYear, selectedQuarter)
      }

      await orchestrator.runOnce({ scheduleUid })

    } catch (err) {
      console.error(err)
      setWaitingForJobs(false)
    }
  }

  return (
    <Button
      style={{ margin: '0px 5px'}}
      onClick={async () => await handleFormSubmission()}
      size="small"
      type="primary"
      shape="round"
      disabled={waitingForJobs}
    >
      { waitingForJobs ? "Wacht Totdat de Taak Opgepakt Wordt" : "Genereer Factuur" }
    </Button>
  )
}

const mapStateToProps = ({ explore: { plugins }}) => ({ plugins })
export default connect(mapStateToProps, null)(GenerateInvoiceButton)
